var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-83c72545.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-26b86ff1.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.69 8.667h30.647c.528 2.514.69 5.055.66 7.35a33.98 33.98 0 0 1-.687 7.316H.682c-.548-2.53-.709-5.063-.679-7.35-.03-2.257.158-4.786.687-7.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M31.338 8.667H.69c.055-.264.114-.528.177-.792 0 0 1.028-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 4.447 1.728 5.476 6.646 5.476 6.646.06.252.118.505.17.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.682 23.333H31.31a29.56 29.56 0 0 1-.177.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124a25.83 25.83 0 0 1-.184-.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m20.401 17.937-1.787 2.537-.172-3.099-2.964-.915 2.893-1.12-.045-3.104 1.96 2.406 2.937-1.002-1.682 2.608 1.86 2.484-3-.795Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M17.556 10.74a5.333 5.333 0 1 0 0 10.519 6 6 0 1 1 0-10.519Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagLby = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagLby_default = SvgFlagLby;
export {
  FlagLby_default as default
};
